import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class PartnerAnalysisGroup2 extends BaseEntity{

    partnerAnalysisGroup2Code : string;
    name : string;
    rank : number;
    
}

